module.exports = __webpack_public_path__ + "s13.no2.748c09db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s13.no2.jpg
// module id = r1/x
// module chunks = 0